import React from "react";
import { IconProps } from "../types/types";

const DoubleQuotationIcon = ({ className, size = 20 }: IconProps) => {
    return (
        <svg
            xmlns="https://www.w3.org/2000/svg"
            viewBox="4.37666 0.37747 38.79024 28.88293"
            width={size}
            className={className}
            height={size}
        >
            <path d="M23.3369 8.16204C22.4829 4.54171 19.4913 1.64062 15.5862 1.09156C10.5038 0.377467 5.80536 3.91811 5.09178 9.00004C4.37666 14.0815 7.91834 18.7799 12.9998 19.4945C14.8136 19.7515 16.663 19.4643 18.3135 18.6693C16.8082 24.1178 13.483 27.9818 7.90805 29.2604C15.8864 28.9375 22.6839 23.3729 23.8345 15.1847C24.1669 12.835 23.9973 10.4414 23.3369 8.16204Z" />
            <path
                transform="translate(19, 0)"
                d="M23.3369 8.16204C22.4829 4.54171 19.4913 1.64062 15.5862 1.09156C10.5038 0.377467 5.80536 3.91811 5.09178 9.00004C4.37666 14.0815 7.91834 18.7799 12.9998 19.4945C14.8136 19.7515 16.663 19.4643 18.3135 18.6693C16.8082 24.1178 13.483 27.9818 7.90805 29.2604C15.8864 28.9375 22.6839 23.3729 23.8345 15.1847C24.1669 12.835 23.9973 10.4414 23.3369 8.16204Z"
            />
        </svg>
    );
};

export default DoubleQuotationIcon;
